// CUSTOM ICON COMPONENT
import duotone from "icons/duotone";

// type ChildItem = { name: string; path: string };

// type ChildItemWithChildren = {
//   name: string;
//   path: string;
//   children?: ChildItemWithChildren[];
// };
export const navigations = [{
  type: "label",
  label: "Dashboard"
}, {
  name: "Dashboard",
  path: "/dashboard/",
  icon: duotone.PersonChalkboard
}, {
  name: "Chats",
  icon: duotone.Chat,
  path: "/dashboard/chat"
}, {
  name: "Users",
  path: "/dashboard/user-list",
  icon: duotone.UserList
}, {
  type: "label",
  label: "Transaction"
}, {
  name: "Deposit",
  path: "/dashboard/deposit-list",
  icon: duotone.BadgeDollar
}, {
  name: "Purchase",
  path: "/dashboard/purchase-list",
  icon: duotone.AdminEcommerce
}, {
  name: "Purchase Ideas",
  path: "/dashboard/purchased-ideas-list",
  icon: duotone.Pages
}, {
  name: "Withdraw",
  path: "/dashboard/withdraw-list",
  icon: duotone.Pricing
}, {
  name: "Subscription",
  path: "/dashboard/subscription-list",
  icon: duotone.Dashboard
}, {
  name: "SMS Parser",
  path: "/dashboard/sms-parser-list",
  icon: duotone.Chat
}, {
  type: "label",
  label: "Article"
}, {
  name: "Article Category",
  path: "/dashboard/articlecategory-list",
  icon: duotone.Folder
}, {
  name: "Article",
  path: "/dashboard/article-list",
  icon: duotone.Pages
}, {
  type: "label",
  label: "Material"
}, {
  name: "Material Category",
  path: "/dashboard/materialcategory-list",
  icon: duotone.RectangleCirclePlus
}, {
  name: "Material",
  path: "/dashboard/material-list",
  icon: duotone.LayerGroup
}, {
  type: "label",
  label: "Calculations"
}, {
  name: "Calculations",
  path: "/dashboard/calculations-list",
  icon: duotone.DiagramProject
}];